import { Button, styled } from '@mui/material'

export const ThinButton = styled(Button)({
  // TODO: change this when thin pixel values are added to theme
  height: '2rem'
})